import useAPI from '@/hooks/useAPI';
import InsuranceRepository from '@/repositories/InsuranceRepository';

const useInsurancePriorityTypes = (enabled = true) => {
  const insuranceRepository = InsuranceRepository();

  return useAPI({
    queryKey: ['getInsurancePriorityTypes'],
    queryFn: async () => {
      return await insuranceRepository.getInsurancePriorityTypes();
    },
    enabled
  });
};

export default useInsurancePriorityTypes;
